import { faSave } from "@fortawesome/free-solid-svg-icons";
import { type FC, useCallback, useState } from "react";
import { useApiCall } from "../api/api";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";
import type { SelectedParticipantRow } from "../pages/BrowseAndFilterPage";

export const BulkContractorRenameModal: FC<{ participants: SelectedParticipantRow[] }> = (
  props,
) => {
  const { bulkRenameContractor } = useApiCall();
  const [contractorName, setContractorName] = useState<string>("");
  const reload = useRefresh();
  const participantIds = props.participants.map((participant) => participant.id);
  const save = async () => {
    await bulkRenameContractor(participantIds, contractorName);
    reload();
  };

  return (
    <>
      <Input
        type={"text"}
        label={"Contractor naam"}
        value={contractorName}
        onChange={setContractorName}
      />
      <ModalFooter text={"Hernoemen"} icon={faSave} onSubmit={save} />
    </>
  );
};
